import { onError } from '@apollo/client/link/error';
import * as Sentry from '@sentry/react';
import { GraphQLFormattedError } from 'graphql/error/GraphQLError';

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
        let error: GraphQLFormattedError = null;
        for (error of graphQLErrors) {
            Sentry.captureException(error, {
                contexts: {
                    graphql: {
                        operation: operation.operationName,
                        variables: operation.variables,
                    },
                },
            });
            console.error('[GraphQL]: Could not fetch data');
        }
    }

    if (networkError) {
        Sentry.captureException(networkError);
        console.error(`[Network]: ${networkError}`);
    }
});

export default errorLink;
